module.exports = __webpack_public_path__ + "img/icon-card-action.2318cbed.svg";